import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import { LabelSize } from './index';
import { StatusIndications } from '../common';

export interface FormFieldDriver extends BaseDriver {
  element: () => HTMLElement;
  getChildren: () => HTMLElement | null;
  getLabel: () => HTMLElement | null;
  getLabelSize: () => LabelSize;
  isRequired: () => boolean;
  getLengthLeft: () => number | null;
  isLengthExceeded: () => boolean;
  hasTooltip: () => boolean;
  getInfoContent: () => string;
  getSuffix: () => HTMLElement | null;
  hoverInfoIcon: () => Promise<void>;
  getStatusMessage: () => string;
  hasStatus: (status: StatusIndications) => boolean;
}
